// 밑줄 탭 — components/CaHeaderTabs.js 문법 복제 (밑줄 3px, on 800/navy, off 600/muted, gap 26/18).
// props: items:[{id,label,badge,on,onClick}] | [{label,href}] (외부 링크, 새 탭) | [{sep}] (구분선 + 작은 묶음 라벨, 예: '관리자 전용'), isMobile
// 클래스 계약: 래퍼 .v2-useg / 항목 .v2-utab (+ .on) — hover·헤더 밀착 CSS 가 v2.css 에서 이 클래스에 걸린다.
import React from 'react';
import { T, FONT } from '../theme';

function HeaderTabs(props) {
  var isMobile = props.isMobile;
  return (<span className="v2-useg" style={{ display: 'inline-flex', alignItems: 'baseline', gap: isMobile ? 18 : 26 }}>
    {(props.items || []).map(function (it) {
      var on = !!it.on;
      var st = { padding: isMobile ? '8px 2px 10px' : '6px 2px 11px', whiteSpace: 'nowrap', fontFamily: 'inherit', cursor: 'pointer',
        background: 'none', border: 'none', borderBottom: '3px solid ' + (on ? T.accent : 'transparent'),
        fontSize: isMobile ? 13 : FONT.tab, fontWeight: on ? 800 : 600, color: on ? T.navy : T.muted, textDecoration: 'none',
        display: 'inline-flex', alignItems: 'baseline', gap: 4 };
      if (it.sep) {
        return (<span key={'sep-' + it.sep} style={{ display: 'inline-flex', alignItems: 'center', gap: 8, alignSelf: 'center' }}>
          <span style={{ width: 1, height: 13, background: T.hair }} />
          <span className="v2-utab-sep" style={{ fontSize: FONT.label, fontWeight: 600, color: T.faint, whiteSpace: 'nowrap' }}>{it.sep}</span>
        </span>);
      }
      var key = it.id || it.label;
      if (it.href) {
        return (<React.Fragment key={key}>
          <span style={{ width: 1, height: 13, background: T.hair, alignSelf: 'center' }} />
          <a className="v2-utab" href={it.href} target="_blank" rel="noopener noreferrer"
            style={Object.assign({}, st, { fontSize: FONT.body, color: T.faint })}>{it.label}</a>
        </React.Fragment>);
      }
      var badge = it.badge;
      return (<button key={key} type="button" className={'v2-utab' + (on ? ' on' : '')} onClick={it.onClick} style={st}>
        {it.label}
        {badge ? <em style={{ fontStyle: 'normal', fontSize: FONT.badge, fontWeight: 800, color: T.card, background: T.red,
          borderRadius: 999, padding: '1px 6px', marginLeft: 4, verticalAlign: 1, fontVariantNumeric: 'tabular-nums' }}>{badge}</em> : null}
      </button>);
    })}
  </span>);
}

export default HeaderTabs;
